import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <header className="header">
        <h1>GearPay</h1>
        <nav>
          <ul>
            <li>Home</li>
            <li>Products</li>
            <li>Contact</li>
          </ul>
        </nav>
      </header>
      <main className="content">
        <h2>Terms and Conditions </h2>
        <p><h3>1. Introduction</h3>
These Terms and Conditions (“Terms and Conditions”) form a legal agreement between
Gear Pay together with all its affiliates and subsidiaries (“Gear Pay” “We”), and you, the
individual (“you” and “your”) concerning your access to and use of the various services
offered through the Sites and the Gear Pay platforms.
These terms and conditions apply to the Gear Pay app and/or website (the “Site”) and all of
its subsidiaries, and affiliates operated Internet sites which reference these Terms and
Conditions.
Use of any of the Sites or platforms constitutes your acceptance of these Terms and
Conditions of use. The Site reserves the right, to change, modify, add, or remove portions
of both the Terms and Conditions of use at any time. Changes will be effective when posted
on the Site with no other notice provided.
Please check these Terms and Conditions regularly for updates. Your continued use of the
Site following the posting of changes to these Terms and Conditions constitutes your
acceptance of those changes.
Kindly review the Terms and Conditions listed below diligently prior to using this website as
your use of the website indicates your agreement to be wholly bound by its Terms and
Conditions without modification.
You agree that if you are unsure of the meaning of any part of these Terms and Conditions
or have any questions regarding the Terms and Conditions, you will not hesitate to contact
us for clarification. These Terms and Conditions fully govern the use of this website. No
extrinsic evidence, whether oral or written, will be incorporated.
<h3>2. Your representations and warranties</h3>
a) By registering on the Platforms, you represent and warrant the following:
you are at least eighteen (18) years of age,
you have the legal ability and authority to enter into these Terms and Conditions with Gear
Pay, the information you have provided to Gear Pay in your registration is accurate and
complete,
you will comply with any and all laws applicable to your use of the Sites and platforms,
you will not interfere with a third party’s use and enjoyment of the Sites and Platforms,
you will not interfere with or disrupt Gear Pay or its vendors’ security measures,
if any information you provide to Gear Pay becomes inaccurate, incomplete or otherwise
false or misleading, you will immediately notify Gear Pay.
<h3>3. Use of Site and Applications</h3>
Both parties agree that this website and applications may only be used in accordance with
these Terms and Conditions of Use. If you do not agree with the Terms and Conditions of
Use or do not wish to be bound by them, you agree to refrain from using this website.
We grant you a non-transferable, revocable and non-exclusive license to use this Site, in
accordance with the Terms and Conditions of use, for the following:
Accessing healthcare information available on the Site and Applications
Connecting with patients and medical practitioners in relation to receipt and provision of
health products and services, telemedicine, book facilities, doctors and expert healthcare
services available on the Site
Gathering prior information regarding our products and services and purchasing or
providing the services.

Private and Confidential
Updated September 2024
Certain services and related features that may be made available on the Site may require
registration or subscription. Should you choose to register or subscribe for any such services
or related features, you agree to provide accurate and current information about yourself,
and to promptly update such information if there are any changes.
Every user of the Site is solely responsible for keeping passwords and other account
identifiers safe and secure.
The account owner is entirely responsible for all activities that occur under such password
or account. Furthermore, you must notify us of any unauthorized use of your password or
account. The Site shall not be responsible or liable, directly or indirectly, in any way for any
loss or damage of any kind incurred as a result of, or in connection with, your failure to
comply with this section. During the registration process you agree to receive promotional
emails from the Site. You can subsequently opt out of receiving such promotional emails by
clicking on the link at the bottom of any promotional email.
<h3>4. Use of the App</h3>
You must be at least 18 years old to use the App.You are responsible for ensuring that all
information provided during registration is accurate and kept up-to-date. You agree to use
the App only for lawful purposes and in accordance with all applicable laws and regulations.
<h3>5. Account Registration</h3>
Users must register an account to access the features of the App. You are responsible for
maintaining the confidentiality of your account and password, and for any activities that
occur under your account. We reserve the right to suspend or terminate your account at any
time, especially in case of unauthorized use.
<h3>6. Payment and E-Commerce</h3>
The App allows users to send payments, make purchases, and conduct transactions. You
agree to provide accurate payment information. All payments and transactions made on the
App are final and non-refundable unless otherwise specified. The exchange rates used for
cross-border remittances are subject to change, and we will not be responsible for any
discrepancies caused by such changes.
<h3>7. Wallet and Financial Planning</h3>
The App provides a wallet feature for saving and financial planning. We do not guarantee
returns or profits from your use of this feature. You are solely responsible for how you
manage and use the funds in your wallet.
<h3>8. Fees and Charges</h3>
Certain features of the App may be subject to fees. These fees will be displayed clearly
before you complete any transaction. A standard fee rate of 1.04% will apply for payments.
We reserve the right to modify our fee structure at any time.
<h3>9. Security and Data Privacy</h3>
We employ industry-standard security measures to protect your data, but we cannot
guarantee that unauthorized access will never occur. You are responsible for securing your
account, devices, and personal information.
<h3>10. Prohibited Activities</h3>
Engaging in fraudulent, illegal, or unauthorized activities, including hacking, phishing, or any
attempts to compromise the App’s security, is strictly prohibited. We reserve the right to
investigate and take legal action in the event of any suspicious activity.
<h3>11. Changes to Terms</h3>
We reserve the right to modify these Terms at any time. We will notify you of any changes
through the App or email. Continued use of the App following changes to the Terms
constitutes acceptance of the new Terms.
<h3>12. Indemnity</h3>
You agree to indemnify and hold us, our affiliates, officers, directors, agents and/or
employees, as the case may be, free from any claim or demand, including reasonable legal
fees, related to your breach of these Terms of use.
<h3>13. Information submitted by you</h3>
Any information that you submit to the Site and/or provide to us, including but not limited
to, questions, reviews, comments, and suggestions will become our sole and exclusive
property and shall not be returned to you.
In addition to the rights applicable to any information, when you post comments or reviews
to the Site, you also grant us the right to use the name that you submit, in connection with
such review, comment, or other content
You shall not use a false e-mail address, pretend to be someone other than yourself or
otherwise mislead us or third parties as to the origin of any Submissions. We may, but shall
not be obligated to, remove or edit any Submissions.
By signing up for health services, you agree to receive a) emails associated with processing
your request, b) promotional emails, SMS and push notifications from Gear Pay.
You may unsubscribe from promotional emails via a link provided in each email. If you would
like us to remove your personal information from our database, unsubscribe from emails
and/or SMS, please email Customer Service email address by country.
<h3>14. Accessibility of Site</h3>
Our aim is to ensure accessibility to the Site at all times, however we make no
representation of that nature and reserves the right to terminate the Site at any time and
without notice.
You accept that service interruption may occur in order to allow for Site improvements,
scheduled maintenance or may also be due to external factors beyond our control
<h3>15. Links and Thirds Party Sites</h3>
We may include links to third party websites at any time. However, the existence of a link to
another website should not be considered as an affiliation or a partnership with a third party
or viewed as an endorsement of a particular website unless explicitly stated otherwise.
In the event the user follows a link to another Site, he or she does so at his or her own risk.
We accept no responsibility for any content, including, but not limited to, information,
products and services, available on third party websites. Creating a link to this website is
strictly forbidden without our prior written consent. Furthermore, we reserve the right to
revoke our consent without notice or justification.
<h3>16. No endorsements</h3>
Reference to any product, recording, event, process, publication, service, or offering of any
third party by name, trade name, trademark, service mark, company name or otherwise does
not constitute or imply the endorsement or recommendation of such by Gear Pay. Any views
expressed by third parties on the Site and platforms are solely the views of such third party
and Gear Pay assumes no responsibility for the accuracy or veracity of any statement made
by such third party.
<h3>17. Intellectual Property</h3>
Both parties agree that all intellectual property rights and database rights, whether
registered or unregistered, in the Site, information content on the Site and all the website
design, including, but not limited to, text, graphics, software, photos, video, music, sound,
and their selection and arrangement, and all software compilations, underlying source code
and software shall remain at all times vested in us or our licensors. Use of such material will
only be permitted as expressly authorized by us or our licensors.
Any unauthorized use of the material and content of this website is strictly prohibited and
you agree not to, or facilitate any third party to, copy, reproduce, transmit, publish, display,
distribute, commercially exploit or create derivative works of such material and content.
<h3>18.Applicable Law and Jurisdiction</h3>
These Terms and Conditions shall be interpreted and governed by English Law. Each party
hereby agrees to submit to the jurisdiction of the English courts.
<h3>19. Arbitration</h3>
The parties shall use their best efforts to amicably settle any dispute arising out of or in
connection with this Agreement (including any question regarding its interpretation
existence validity or termination). If such dispute controversy or claim cannot be settled
within ten (10) days after receipt by one party of the other party’s request for such amicable
settlement, the parties shall refer the dispute to a mediator agreed upon between them in
accordance with the LCIA Mediation Rules, which Rules are deemed to be incorporated by
reference into this clause, and if within ten (10) days of one party requesting mediation the
parties do not agree on a mediator or fail to settle the dispute through mediation, the
dispute shall be referred to and finally resolved by arbitration under the London Court of
International Arbitration (LCIA) Rules, which Rules are deemed to be incorporated by
reference into this clause.
The language to be used in the mediation and in the arbitration shall be English.
In any arbitration commenced pursuant to this clause:
the number of arbitrators shall be three; and
the seat, or legal place, of arbitration shall be London.
The award of the arbitrators shall be final and binding upon the parties and any party may
apply to a court of competent jurisdiction for enforcement of such award. The award of the
arbitrators may take the form of an order to pay an amount or to perform or to prohibit
certain activities.
Notwithstanding the foregoing, a Party is entitled to seek preliminary injunctive relief or
interim or conservatory measures from any court of competent jurisdiction pending the
final decision or award of the arbitrators.
<h3>20. Termination</h3>
In addition to any other legal or equitable remedies, we may, without prior notice to you,
immediately terminate the Terms and Conditions or revoke any or all of your rights granted
under the Terms and Conditions. Upon any termination of this Agreement, you shall
immediately cease all access to and use of the Site and we shall, in addition to any other
legal or equitable remedies, immediately revoke all password(s) and account identification
issued to you and deny your access to and use of this Site in whole or in part. Any termination
of this agreement shall not affect the respective rights and obligations (including without
limitation, payment obligations) of the parties arising before the date of termination. You
furthermore agree that the Site shall not be liable to you or to any other person as a result
of any such suspension or termination. If you are dissatisfied with the Site or with any terms,
conditions, rules, policies, guidelines, or practices of Gear Pay in operating the Site, your
sole and exclusive remedy is to discontinue using the Site.
<h3>21. Severability</h3>
If any portion of these terms or conditions is held by any court or tribunal to be invalid or
unenforceable, either in whole or in part, then that part shall be severed from these Terms
and Conditions of Use and shall not affect the validity or enforceability of any other section
listed in this document.
<h3>22. Electronic documents</h3>
This electronic document, and all other electronic documents referred to or incorporated
herein, will be: (a) deemed for all purposes to be a “writing” or “in writing”, and to comply
with all statutory, contractual, and other legal requirements for a writing; and (b) legally
enforceable as a signed agreement. A printed version of these Terms and Conditions and
any notice given in electronic form shall be admissible in judicial proceedings or
administrative proceedings based upon or relating to these Terms and Conditions to the
same extent and subject to the same conditions as other business documents and records
originally generated and maintained in printed form.
<h3>23. Assignment</h3>
These Terms and Conditions are personal to you, and are not assignable, transferable, or
sub licensable by you except with Gear Pay’ prior written consent. Gear Pay may assign,
transfer, or delegate any of its rights and obligations hereunder without your consent.
<h3>24. Disclaimer</h3>
The Site and platforms are provided on an “as is” and “as available” basis and without
warranties of any kind, either express or implied. To the fullest extent permissible pursuant
to applicable law, Gear Pay disclaims all representations, warranties, and conditions, express
or implied, including, but not limited to, implied condition or warranties of merchantability
and fitness for a particular purpose.
Gear Pay does not warrant that the Site and platforms will be uninterrupted or error-free,
that defects will be corrected or that the Site and Platforms or the server that makes it
available are free of viruses or other harmful components.
Healthcare service representations expressed on this Site are those of the healthcare
service providers and are not made by us. Submissions or opinions expressed on this Site
are those of the individual posting such content and may not reflect our opinions.
Gear Pay makes no guarantees, and disclaims any implied warranty or representation about
its accuracy, relevance, timeliness, completeness, or appropriateness of any content posted
on the Site and platforms for a particular purpose. Gear Pay assumes no liability arising from
or relating to any error, omission, interruption, deletion, delay in operation or transmission,
computer virus, communication failure and defect in the information, content, materials,
software or other services, failure, interruption, or corruption of any data or other
information transmitted in connection with use of the Site and/or Platforms.
Applicable law may not allow the exclusion of implied warranties, so the above exclusion
may not apply to you.
<h3>25. Contacts/Notices</h3>
If you have any questions about the Terms and Conditions, or need to provide notice to, or
communicate with, Gear Pay under the Terms and Conditions, please contact Gear Pay using
the following contact details: info@gearpay.app </p>
        <section className="terms">
          <h3>Privacy Policy</h3>
          <p>
          Privacy Policy
At Gear Pay, we are committed to protecting your privacy and we take great care with your
Personal Data.
This privacy policy explains what Personal Data we collect from you, what we use that
Personal Data for, with whom the Personal Data is shared and how it is protected and
stored. It also sets out your rights and who you can contact for Personal Data or queries.
If you have any questions, feel free to contact us at info@gearpay.app .
This privacy policy should be read together with our Terms and Conditions, which together
apply to your use of the Gear Pay website, platform and applications.
Kenya Data Protection Act 2019
Under the above Act, we are a Data Controller of your information.
Gear Pay’ legal basis for collecting and using the personal information described in this
Privacy Policy depends on the Personal Information we collect and the specific context in
which we collect the information:
Gear Pay needs to perform a contract with you
You have given Gear Pay permission to do so
Processing your personal information is in Gear Pay legitimate interests
Gear Pay needs to comply with the law
Gear Pay will retain your personal information only for as long as is necessary for the
purposes set out in this Privacy Policy. We will retain and use your information to the extent
necessary to comply with our legal obligations, resolve disputes, and enforce our policies.
If you are a resident of Kenya, you have certain data protection rights. If you wish to be
informed what Personal Information, we hold about you and if you want it to be removed
from our systems, please contact us at info@gearpay.app
In certain circumstances, you have the following data protection rights:
• The right to access, update or to delete the information we have on you.
• The right of rectification.
• The right to object.
• The right of restriction.
• The right to data portability
• The right to withdraw consent

By accessing or using the Gear Pay Website, Application and associated services, you agree
to the practices and policies outlined in this privacy policy and you hereby consent to the
collection, use, and sharing of your Personal Data as described in this privacy policy
Personal Data” means Personal Data about a natural person who is identified or can be
identified from that Personal Data (either by itself or when combined with other Personal
Data).
<h3>1. What Personal Data do we collect?</h3>
Online and Offline Payment Processing Information
When you make a payment through our services, your payment card Personal Data is
collected and stored by our payment processing partner. Our payment processing partner
collects your voluntarily provided payment card Personal Data necessary to process your
payment. Such partner’s use and storage of Personal Data is governed by its applicable
terms of service and privacy policy.
Information from Third-Party Sources
Some third parties, such as our business partners and service providers, provide us with
Personal Data about you. If you interact with a third-party service when using our services,
such as if you use a third-party service to log-in to our services (e.g., Facebook or Google),
or if you share content from our services through a third party social media service, the
third-party service will send us certain Personal Data about you if the third-party service and
your account settings allow such sharing. The Personal Data we receive will depend on the
policies and your account settings with the third-party service. You understand the Personal
Data transmitted to us is covered by this Privacy Policy; for example, the basic Personal Data
we receive from Google if you choose to sign up with your Google account.
Information Gear Pay Automatically Collects When You Use The services
GEAR PAY AND ALL SUBSIDIARIES.
Some Personal Data, which may include Personal Data, is automatically collected when you
use our services, such as traffic data. We also may automatically collect certain data when
you use the services, such as (1) IP address; (2) domain server; (3) type of device(s) used to
access the services; (4) web browser(s) used to access the services; (5) referring webpage or
other source through which you accessed the services; (6) geolocation Personal Data; and(7)
other statistics and Personal Data associated with the interaction between your browser or
device and the services.
<h3>2. How Gear Pay Collects Information</h3>
Gear Pay collects Personal Data (including Personal Data and traffic data) when you use and
interact with the services, and in some cases from third party sources. Such means of
collection include:
• When you use the services’ interactive tools and services, such as searching for
Products and Services and searching for available services;
• When you voluntarily provide Personal Data in free-form text boxes through the
services or through responses to surveys;
• If you download and install certain applications and software we make available, we
may receive and collect Personal Data transmitted from your computing device for
the purpose of providing you the relevant services;
• If you use a location-enabled browser or download our mobile application, we may
receive Personal Data about your location and mobile device, as applicable;
• Through cookies, analytics services and other tracking technology, as
• When you use the “Contact Us” function on the Site, send us an email or otherwise
contact us.
<h3>3. For what purpose do we collect the Personal Data?</h3>
We collect this data to improve services for the user and have better experience.
<h3>4. Tracking Tools</h3>
We may use tools outlined below in order to provide our services to, advertise to, and to
better understand users.
Cookies: “Cookies” are small computer files transferred to your computing device that
contain Personal Data such as user ID, user preferences, lists of pages visited and activities
conducted while using the services. We use cookies to improve or tailor the services,
customize advertisements by tracking navigation habits, measuring performance, and
storing authentication status so re-entering credentials may not be required, customize
user experiences with the services, and for analytics and fraud prevention.
Web Analytics services: We may use third-party analytics services in connection with our
services, including, for example, to collect your country where you are logging on, IP
address, time spent on the Website or mobile applications, pages visited and other user
Personal Data.
<h3>5. Who do we share this Personal Data with?</h3>
We may disclose and transfer your Personal Data in connection with such partners’ use of
the services
In certain circumstances, and in order to perform the services, we may share certain
Personal Data that we collect from you to select third parties, agents, contractors and
service providers or partners with restrictions that they may not use your Personal Data for
any other purposes and on the basis of a Non-Disclosure agreement and subject to
compliance with Data Protection Laws, as described in this section:
Healthcare Providers: We may share your Personal Data with merchants with whom you
choose to buy the services or products.
We will never sell email addresses to third parties. We may share your Personal Data with
our partners to customize or display our advertising.
We may share your Personal Data and/or traffic data with our partners who perform
operational services (such as hosting, billing, fulfilment, data storage, security, insurance
verification, web service analytics, or ad serving) and/or who make certain services, features
or functionality available to our users.
We may share your Personal Data with the insurance service provider you identify to us (and
do so via our partners) to determine eligibility or otherwise obtain benefit plans and other
insurance-related Personal Data on your behalf.
Public Information and Submissions: You agree that any Personal Data that you may reveal
in a review posting, online discussion or forum is intended for the public and is not in any
way private. Carefully consider whether to disclose any Personal Data in any public posting
or forum. Your submissions may be seen and/or collected by third parties and may be used
by others in ways we are unable to control or predict.
Protection of Gear Pay and Others: We also may need to disclose your Personal Data or any
other Personal Data we collect about you if we determine in good faith that such disclosure
is needed to: (1) comply with or fulfil our obligations under applicable law, regulation, court
order or other legal process; (2) protect the rights, property or safety of you, Gear Pay or
another party; (3) enforce the Agreement or other agreements with you; or (4) respond to
claims that any posting or other content violates third-party rights.
<h3>6. International Data Transfers</h3>
From time to time, Gear Pay may need to transfer your Personal Data outside of the country
or may receive Personal Data from outside of the country as part of its service delivery. Both
the receiving and disclosing parties shall ensure adequate safeguards with respect to
security and protection of Personal Data are in place in compliance to Data Protection laws.
<h3>7. How secure is your Personal Data?</h3>
We are committed to protecting the security of your Data. We use a variety of security
technologies and procedures to help protect your Data from unauthorised access and use.
For orders specifically through our site and app’s we secure the data on GDPR compliant
AWS servers hosted in the European Union.
We have implemented strict internal guidelines to ensure that your privacy is safeguarded
at every level of our organisation. We will continue to update policies and implement
additional security features as new technologies become available.
We endeavour to follow generally accepted industry standards to protect the Personal Data
submitted to us, both during transmission and in storage as follows;
a. A firewall to prevent unauthorized external access to our system.
b. Your account or profile is protected by a password for your privacy and security. If
you access your account via a third-party site or service, you may have additional or
different sign-on protections via that third-party site or service. You must prevent
unauthorized access to your account and Personal Data by selecting and protecting
your password and/or other sign-on mechanism appropriately and limiting access to
your computer or device and browser by signing off after you have finished
accessing your account.
c. SSL certificates for customer-facing websites and external connections, except
connections that go through a secured VPN.
d. Our systems have capability to detect any data security breaches and timely
appropriate action taken to remedy.
e. All our employees are trained to ensure high standards in relation to data protection.
f. We use best efforts to keep confidential any Personal Data collected which may be
of confidential nature, with the exception of such Personal Data which:
o was already known to us prior to receiving such Personal Data from the end
user.
o was received from a third party who is not subject to similar confidentiality
restrictions.
o is independently developed by us; and/or
o is required to be disclosed by applicable Law.
Notwithstanding clause above, we reserve the right to disclose any Personal Data
collected to any person if, in our reasonable opinion, it is:
o required by applicable Law.
o necessary to comply with a court order or other legal process.
We shall take all reasonable precautions to preserve the integrity and prevent any
corruption or loss, damage or destruction of Personal Data in our possession
g. Our security practices and procedures are certified and are audited on a regular
basis.
h. Although we make best possible efforts to transmit and store all the Personal Data
in a secure operating environment that is not open to the public, there is no such
thing as complete security, and we do not guarantee that there will be no
unintended disclosures of any Information Collected. If We become aware that any
Personal Data has been disclosed in a manner that is not in accordance with this
Policy, We will use best efforts to notify you of the nature and extent of such
disclosure (to the extent of our knowledge) as soon as reasonably possible and as
permitted by Law.
i. We store and process your Personal Data on our servers in Amazon Web Services.
We maintain industry standard backup and archival systems.
j. Although we make good faith efforts to store Personal Data in a secure operating
environment that is not open to the public, we do not and cannot guarantee the
security of your Personal Data. If at any time during or after our relationship we
believe that the security of your Personal Data may have been compromised, we may
seek to notify you of that development. If a notification is appropriate, we will
endeavour to notify you as promptly as possible under the circumstances. If we have
your e-mail address, we may notify you by e-mail to the most recent e-mail address
you have provided us in your account profile. Please keep your e-mail address in your
account up to date which can be updated at any time in your account profile.
<h3>8. What Choices Do You Have When Using The Service</h3>
You can always opt not to disclose Personal Data to us, but keep in mind some Personal
Data may be needed to register with us or to take advantage of some of our features.
If you are a registered user of the services, you can modify certain Personal Data or account
Personal Data by logging in and accessing your account. The Personal Data you can view,
update, and delete may change as the services change.
If you wish to close your account, please email us at info@gearpay.app . Gear Pay will use
reasonable efforts to promptly delete your account and the related Personal Data. Please
note, however, that Gear Pay reserves the right to retain Personal Data from closed
accounts, including to comply with law, prevent fraud, resolve disputes, enforce the
agreement and take other actions permitted by law.
You must promptly notify us if any of your account data is lost, stolen or used without
permission.
<h3>9.For how long do we keep your Personal Data? Where do we keep it? How do we keep
it?
</h3>
We retain Personal Data about you for as long as you have an open account with us or as
otherwise necessary to provide you services. In some cases, we retain Personal Data for
longer, if doing so is necessary to comply with our legal obligations, resolve disputes or
collect fees owed, prevent fraud, enforce the Agreement, or as otherwise permitted or
required by applicable law, rule or regulation. Afterwards, we retain some Personal Data in
a depersonalized or aggregated form but not in a way that would identify you personally.
<h3>10. Information Provided on Behalf of Minors and Others</h3>
As noted in the Terms of Use, the services are not intended for use by children and children
under the age of 18 should not use our service. Gear Pay does not knowingly collect any
Personal Data from minors, nor is the services directed to or attended for use by children.
If you are under 18, please do not attempt to register for the services or send any Personal
Data about yourself to us.
If you are a parent or legal guardian of a minor, you may, in compliance with the Agreement,
use the services on behalf of such minor. Any Personal Data that you provide us while using
the services on behalf of your minor child will be treated as Personal Data as otherwise
provided herein.
If you use the services on behalf of another person, regardless of age, you agree that Gear
Pay may contact you for any communication made in connection with providing the services
or any legally required communications. You further agree to forward or share any such
communication with any person on behalf of whom you are using the services.
<h3>11. Other Web services</h3>
The services contain links to or embedded content from third party web services. A link to
or embedded content from a non-Gear Pay web service does not mean that we endorse that
service, the quality or accuracy of Personal Data presented on the non-Gear Pay service or
the persons or entities associated with the non-Gear Pay service. If you decide to visit a

third-party web service, you are subject to the privacy policy and Terms of Use of the third-
party web service as applicable and we are not responsible for the policies and practices of

the third-party web service. We encourage you to ask questions before you disclose your
Personal Data to others.
You may have arrived at the services from, or begun your use of the services at, a third-party
web service, including a third-party web service that links to Gear Pay or embeds Gear Pay
content. The presence of such links or content on third-party web services does not mean
that we GEAR PAY endorse that web service and applications, the quality or accuracy of
Personal Data presented on the non-Gear Pay web service or the persons or entities
associated with the non-Gear Pay web service. You may be subject to the privacy policy of
the third-party web service as applicable and we are not responsible for the policies and
practices of the third-party web services. In addition, the policies and practices of third
parties do not apply to your Personal Data, including Personal Data, obtained pursuant to
this Privacy Policy.
<h3>12. What are your rights as a data subject?</h3>
We have mechanisms in place to ensure that you can exercise the following legal rights.
a. Right to give and withdraw consent at any time
b. Right to be informed of the use to which Personal Data is to be put
c. Right to access your Personal Data
d. Right to object to the processing of all or part of your Personal Data unless there is
a compelling legitimate interest or for legal purposes
e. Right to request confirmation of what Personal Data is held
f. Right to request correction of any errors, omissions, out-dated, Personal Data
inaccurate, incomplete or misleading personal data, and request third parties
processing the personal data of the request. This will however not apply to Personal
Data required for legal purposes
g. Right to request cessation of use the Personal Data
h. Right to request removal from any contact/mailing list
i. Right to restrict use of your Personal Data
j. Right to request deletion of Personal Data that is irrelevant, excessive or obtained
unlawfully, and request third parties processing the Personal Data of the request.
This will however not apply to Personal Data required for legal purposes
k. Right to request transfer of Personal Data to another organisation
<h3>13. Review of Policy</h3>
The effective date of this Privacy Policy is set forth at the top of this webpage. We will notify
you of any material change by posting notice on this webpage. Your continued use of the
services after the effective date constitutes your acceptance of the amended Privacy Policy.
We encourage you to periodically review this page for the latest Personal Data on our
privacy practices. Any amended Privacy Policy supersedes all previous versions. If you do not
agree to future changes to this privacy policy, you must stop using the services after the
effective date of such changes
<h3>Consent statement</h3>
By using our platforms and applications you consent to have read and understood, and
agree to Gear Pay' privacy policy, and applicable terms and conditions.
You are also aware that you can withdraw your consent at any time by sending an email to
info@gearpay.app .
          </p>

        </section>
      </main>
      <footer className="footer">
        <p>© 2024 GearPay. All rights reserved.</p>
        <ul className="footer-links">
          <li>Privacy Policy</li>
          <li>Terms and Conditions</li>
        </ul>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
